import type { Credentials } from '../network/protocol';

/** The crew is stable across transfers. Current region belongs to the route
 * objective, not the original lobby seed (which can describe a different train).
 * Offline worlds also select a stage independently of their scenery seed.
 */
export function runIdentityLabel(
  credentials: Pick<Credentials, 'lobbyCode'> | undefined,
  training: boolean,
): string {
  return credentials
    ? `${training ? 'DRILL' : 'LIVE'} // ${credentials.lobbyCode}`
    : 'LOCAL // FREE RUN';
}
